var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepageHeroDecoration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 873,
    viewBox: "0 0 1600 873",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_21379)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1454.51 727.469H1600C1600 650.275 1569.34 576.242 1514.77 521.657C1460.21 467.073 1386.2 436.407 1309.02 436.407V581.938C1347.61 581.938 1384.61 597.271 1411.9 624.563C1439.18 651.855 1454.51 688.872 1454.51 727.469Z",
    fill: "#606AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.19 829.598C1384.33 856.467 1347.98 871.664 1310.02 871.927V728.399H1453.51C1453.25 766.37 1438.05 802.729 1411.19 829.598Z",
    stroke: "#606AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.085 531.604C741.335 505.534 728.696 472.175 728.445 437.593H871.93V581.071C865.727 581.014 859.533 580.578 853.383 579.765C818.777 575.033 787.055 557.925 764.085 531.604Z",
    stroke: "#606AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.808 538.792C161.947 511.923 146.754 475.564 146.492 437.593H289.976V581.12C252.017 580.858 215.669 565.661 188.808 538.792Z",
    stroke: "#606AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.44 540.02C1232.68 567.264 1269.53 582.672 1308.02 582.935V726.467C1270.28 726.34 1232.93 718.844 1198.05 704.396C1162.87 689.82 1130.9 668.454 1103.97 641.519C1077.04 614.583 1055.69 582.606 1041.11 547.413C1026.67 512.527 1019.18 475.16 1019.05 437.407H1162.54C1162.8 475.908 1178.2 512.776 1205.44 540.02Z",
    stroke: "#606AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 381.198C140.758 398.457 144.438 416.933 144.489 435.593H1V292.13C19.6547 292.173 38.1264 295.845 55.3844 302.946C72.9493 310.174 88.9091 320.81 102.342 334.241C115.776 347.671 126.416 363.631 133.65 381.198Z",
    stroke: "#606AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.03 254.269C1377.96 277.022 1344.6 289.657 1310.02 289.896V146.369H1453.67C1453.51 152.582 1453.02 158.783 1452.2 164.946C1447.46 199.565 1430.35 231.297 1404.03 254.269Z",
    stroke: "#606AF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.02 145.345V0.185456C1309.02 0.185456 1300.75 -0.208748 1290.83 0.185456C1181.48 4.77016 1077.84 50.2788 1000.45 127.693C923.066 205.107 877.576 308.777 872.999 418.158C872.582 428.106 872.999 436.407 872.999 436.407H1018.12C1018.12 359.225 1048.76 285.203 1103.32 230.62C1157.87 176.037 1231.86 145.364 1309.02 145.345Z",
    fill: "#606AF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_21379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 873,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageHeroDecoration);
export default __webpack_public_path__ + "static/media/homepage-hero-decoration.ab88e3c1515470c235b56f3703f430bc.svg";
export { ForwardRef as ReactComponent };